<div *transloco="let t">
	<div class="footer flex">
		<div class="flex-auto flex w-100" style="flex-direction: row">
			<div #legalNoticeDiv class="footer-element">
				@if (showLegalNotice) {
					<a class="flex-start clickable" (click)="goToLegalNotice()">{{ t('footer.legalNotice') }}</a>
				}
			</div>

			<div #privacyDiv class="footer-element">
				@if (showPrivacy) {
					<a class="flex-start clickable" (click)="goToPrivacy()">{{ t('footer.privacy') }}</a>
				}
			</div>

			<div #flexDiv [style.width]="flexWidth"></div>

			<div #versionDiv class="flex-end footer-element" style="margin-left: auto">
				<div class="action flex-end">Version {{ version }}</div>
			</div>
		</div>
	</div>
</div>
